import React, {useState, useEffect, useCallback, useMemo} from 'react';
import {FaArrowLeft, FaCheck} from 'react-icons/fa';
import Post from './components/Post';
import Get from './components/Get';
import {useNavigate, useLocation} from 'react-router-dom';

export default function PostFree({dataFromRoute, goBack}) {
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);
  const [array, setArray] = useState([]);
  const [walletBalance, setWalletBalance] = useState(0);
  const [fkGameTimerId, setFkGameTimerId] = useState(null);
  const [biddingType] = useState('open');
  const [gameName, setGameName] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const params = location.state?.data || {};

  const wallet = useCallback(() => {
    Get.Wallet().then(res => {
      if (res.wallet) {
        setWalletBalance(res.wallet.balance);
      }
    });
  }, []);

  const totalAmount = useCallback((dataList, arrayList) => {
    let total = 0;
    dataList.forEach(item => {
      if (item) total += parseFloat(item.amount);
    });
    arrayList.forEach(item => {
      if (item) total += parseFloat(item.amount);
    });
    setTotal(total);
  }, []);

  const enter = useCallback(
    (value, key, type) => {
      const regx = /[^0-9]/;
      if (regx.test(value)) {
        alert("Please Enter Correct Amount. Don't use special characters.");
      } else {
        value = value.replace('-', '');
        const newData = [...data];
        if (value) {
          newData[key] = {amount: value, number: key, type};
        } else {
          delete newData[key];
        }
        setData(newData);
        totalAmount(newData, array);
      }
    },
    [data, array, totalAmount],
  );

  const bahar = useCallback(
    (value, key, type) => {
      const regx = /[^0-9]/;
      if (regx.test(value)) {
        alert("Please Enter Correct Amount. Don't use special characters.");
      } else {
        value = value.replace('-', '');
        const newArray = [...array];
        if (value) {
          newArray[key] = {amount: value, number: key, type};
        } else {
          delete newArray[key];
        }
        setArray(newArray);
        totalAmount(data, newArray);
      }
    },
    [array, data, totalAmount],
  );

  const numbers = useMemo(
    () =>
      Array.from({length: 10}, (_, i) => (
        <div key={`a-${i}`} style={styles.colNumber}>
          <div style={styles.numberHeader}>
            <span style={styles.numberText}>{i}</span>
          </div>
          <input
            type="number"
            value={data[i]?.amount || ''}
            onChange={e => enter(e.target.value, i, 'a')}
            placeholder="₹"
            style={styles.TextField}
          />
        </div>
      )),
    [data, enter],
  );

  const numbers_b = useMemo(
    () =>
      Array.from({length: 10}, (_, i) => (
        <div key={`b-${i}`} style={styles.colNumber}>
          <div style={styles.numberHeader}>
            <span style={styles.numberText}>{i}</span>
          </div>
          <input
            type="number"
            value={array[i]?.amount || ''}
            onChange={e => bahar(e.target.value, i, 'b')}
            placeholder="₹"
            style={styles.TextField}
          />
        </div>
      )),
    [array, bahar],
  );

  useEffect(() => {
    if (params.id) {
      setFkGameTimerId(params.id);
      setGameName(params.name?.name || 'Harup');
    } else {
      setGameName('Harup');
    }
    wallet();
  }, [params.id, params.name?.name, wallet]);

  const submit = () => {
    const finalData = [...data, ...array].filter(item => item);
    if (finalData.length === 0) {
      alert('Please place a bet before submitting.');
      return;
    }

    if (!fkGameTimerId) {
      alert('Game ID is missing. Please try again.');
      return;
    }

    Post.Bidding({
      data: finalData,
      bidding_type: biddingType,
      fk_game_timer_id: fkGameTimerId,
    }).then(res => {
      if (res.success) {
        setData([]);
        setArray([]);
        setTotal(0);
        alert('Your Harup Submitted Successfully.');
        wallet();
        if (goBack) goBack();
      } else {
        alert('Error: ' + (res.errorMsg || 'An error occurred.'));
      }
    });
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.headerContainer}>
        <button style={styles.backButton} onClick={() => navigate(-1)}>
          <FaArrowLeft size={20} color="#FFFFFF" />
        </button>
        <span style={styles.headerTitle}>{gameName}</span>
        <div style={styles.headerPlaceholder}></div>
      </div>

      {/* Content */}
      <div style={styles.scrollContainer}>
        <div style={styles.gameCard}>
          <div style={styles.gameHeader}>
            <h3 style={styles.gameTitle}>Andar Harup</h3>
          </div>
          <div style={styles.numbersGrid}>{numbers}</div>
        </div>

        <div style={styles.gameCard}>
          <div style={styles.gameHeader}>
            <h3 style={styles.gameTitle}>Bahar Harup</h3>
          </div>
          <div style={styles.numbersGrid}>{numbers_b}</div>
        </div>
      </div>

      {/* Bottom bar */}
      <div style={styles.bottomBar}>
        <div style={styles.totalContainer}>
          <div style={styles.totalCard}>
            <span style={styles.totalAmount}>₹{total}</span>
            <h6 style={styles.totalLabel}>Total Amount</h6>
          </div>
        </div>
        <button style={styles.submitButton} onClick={submit}>
          <FaCheck size={18} color="#FFFFFF" style={{marginRight: 8}} />
          Submit
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {backgroundColor: '#F8FAFB', minHeight: '100vh'},
  headerContainer: {
    backgroundColor: '#1057D7',
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  backButton: {
    width: '40px',
    height: '40px',
    borderRadius: '20px',
    backgroundColor: 'rgba(255,255,255,0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
  },
  headerTitle: {fontSize: '18px', fontWeight: '700', color: '#FFFFFF'},
  headerPlaceholder: {width: '40px'},
  scrollContainer: {padding: '20px'},
  gameCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    padding: '15px',
    marginBottom: '20px',
  },
  gameHeader: {
    marginBottom: '10px',
    borderBottom: '1px solid #E5E7EB',
    paddingBottom: '5px',
  },
  gameTitle: {fontSize: '16px', fontWeight: '600', color: '#1F2937'},
  numbersGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  colNumber: {width: '60px', margin: '5px', textAlign: 'center'},
  numberHeader: {
    backgroundColor: '#1057D7',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    padding: '5px',
  },
  numberText: {color: '#FFFFFF', fontSize: '14px', fontWeight: '600'},
  TextField: {
    width: '90%',
    height: '40px',
    border: '1.5px solid #10C2AA',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: '600',
    color: '#EDA01E',
    backgroundColor: '#F9FAFB',
  },
  bottomBar: {
    backgroundColor: '#FFFFFF',
    padding: '10px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderTop: '1px solid #E5E7EB',
  },
  totalContainer: {flex: 1},
  totalCard: {
    backgroundColor: '#F3DE11',
    borderRadius: '12px',
    padding: '8px',
    border: '1px solid #EDA01E',
    textAlign: 'center',
  },
  totalAmount: {fontSize: '16px', fontWeight: '700', color: '#1057D7'},
  totalLabel: {
    fontSize: '12px',
    color: '#6B7280',
    fontWeight: '500',
    margin: 0,
  },
  submitButton: {
    backgroundColor: '#21CB84',
    padding: '15px 24px',
    borderRadius: '12px',
    color: '#FFFFFF',
    fontWeight: '600',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    marginLeft: '15px',
  },
};
